import { useState } from 'react';
import { useNavigate } from 'react-router';
import { SIGNUP_STEPS, WEIGHT_UNIT } from '../../types/enum';
import { convertWeight } from '../../lib/utils';
import request from '../../lib/request';
import FullName from './steps/fullname';
import Nickname from './steps/nickname';
import GenderBirth from './steps/genderBirth';
import HeightWeight from './steps/heightWeight';
import Nationality from './steps/nationality';
import Email from './steps/email';
import Password from './steps/password';
import Goal from './goals';
import Logo from '../../components/logo';

const SignUp = () => {
  const navigate = useNavigate();

  const [currentStep, setCurrentStep] = useState(SIGNUP_STEPS.NAME);

  const [firstname, setFirstname] = useState('');
  const [lastname, setLastname] = useState('');
  const [nickname, setNickname] = useState('');
  const [height, setHeight] = useState('');
  const [weight, setWeight] = useState('');
  const [birth, setBirth] = useState('');
  const [gender, setGender] = useState('');
  const [country, setCountry] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [submitLoading, setSubmitLoading] = useState(false);
  const [userId, setUserId] = useState(null);
  const [weightUnit, setWeightUnit] = useState(WEIGHT_UNIT.KG);

  const handleWeightUnit = () => {
    if (weightUnit === WEIGHT_UNIT.KG) {
      setWeightUnit(WEIGHT_UNIT.LB);
    } else {
      setWeightUnit(WEIGHT_UNIT.KG);
    }
  };

  const handleSubmit = async () => {
    setSubmitLoading(true);
    try {
      const isValid =
        firstname &&
        lastname &&
        nickname &&
        gender &&
        height &&
        weight &&
        birth &&
        country &&
        email &&
        password &&
        confirmPassword;

      if (!isValid) {
        return alert('Please complete the form');
      }

      const { result } = await request.post('/signup', {
        firstname,
        lastname,
        nickname,
        gender,
        height,
        weight:
          weightUnit === WEIGHT_UNIT.LB
            ? Math.ceil(convertWeight(weight, WEIGHT_UNIT.LB, WEIGHT_UNIT.KG))
            : weight,
        birth,
        country,
        email,
        password,
        emailVerified: true,
      });

      if (result) {
        setUserId(result);
      }

      alert(`Welcome ${nickname}, You've signed up successfully.`);
    } catch (err) {
      console.log(err);
      alert(`${email} is not allowed sign up. Please contact support.`);
      window.location.href = '/start';
    } finally {
      setSubmitLoading(false);
    }
  };

  return (
    <div
      className='flex flex-col items-center justify-between min-h-dvh'
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.5)), url("https://static-resource.thechamps.app/img/login.png")`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className='mt-4 flex items-center justify-between w-full px-6'>
        <div
          className='text-white text-2xl'
          onClick={() => navigate('/start')}
        >
          ‹
        </div>
        <Logo size='text-4xl' />
        <div></div>
      </div>
      <div className='p-6 w-full max-w-sm'>
        <div className='mb-5'>
          {currentStep === SIGNUP_STEPS.NAME && (
            <FullName
              firstname={firstname}
              setFirstname={setFirstname}
              lastname={lastname}
              setLastname={setLastname}
              setCurrentStep={setCurrentStep}
            />
          )}
          {currentStep === SIGNUP_STEPS.NICKNAME && (
            <Nickname
              nickname={nickname}
              setNickname={setNickname}
              setCurrentStep={setCurrentStep}
            />
          )}
          {currentStep === SIGNUP_STEPS.GENDER_AGE && (
            <GenderBirth
              gender={gender}
              setGender={setGender}
              birth={birth}
              setBirth={setBirth}
              setCurrentStep={setCurrentStep}
            />
          )}
          {currentStep === SIGNUP_STEPS.HEIGHT_WEIGHT && (
            <HeightWeight
              height={height}
              setHeight={setHeight}
              weight={weight}
              setWeight={setWeight}
              setCurrentStep={setCurrentStep}
              weightUnit={weightUnit}
              handleWeightUnit={handleWeightUnit}
            />
          )}
          {currentStep === SIGNUP_STEPS.NATIONALITY && (
            <Nationality
              country={country}
              setCountry={setCountry}
              setCurrentStep={setCurrentStep}
            />
          )}
          {currentStep === SIGNUP_STEPS.EMAIL && (
            <Email
              email={email}
              setEmail={setEmail}
              setCurrentStep={setCurrentStep}
            />
          )}
          {currentStep === SIGNUP_STEPS.PASSWORD && (
            <Password
              password={password}
              setPassword={setPassword}
              confirmPassword={confirmPassword}
              setConfirmPassword={setConfirmPassword}
              setCurrentStep={setCurrentStep}
              handleSubmit={handleSubmit}
              submitLoading={submitLoading}
            />
          )}
          {currentStep === SIGNUP_STEPS.GOAL && (
            <Goal
              userDetail={{
                userId,
                height,
                weight,
                gender,
                birth,
              }}
              weightUnit={weightUnit}
              handleWeightUnit={handleWeightUnit}
            />
          )}
        </div>
        <p className='text-base text-white text-center mt-2'>
          Already have any account?{' '}
          <a
            onClick={() => navigate('/signin')}
            className='text-white font-semibold underline ml-2'
          >
            Sign In
          </a>
        </p>
      </div>
    </div>
  );
};

export default SignUp;
